import React, { useState, useEffect , useRef} from "react";

import "../Forms/Form.css";
// import "../../Components/Commons/Commons";

import { useProSidebar } from "react-pro-sidebar";


import backarrow from "../../Assets/Icons/back-arrow.png";

import { useNavigate } from "react-router-dom";
import TextField from "../../Components/Commons/Forms/TextField";
import SelectField from "../../Components/Commons/Forms/SelectField";
import CheckBtn from "../Commons/Forms/CheckBtn";
import TextArea from "../Commons/Forms/TextArea";
import BtnSave from "../Commons/Buttons/BtnSave";
import { useReactToPrint } from "react-to-print";
import PrintMedicalAbstract from "../../Components/Forms/MedicalAbstract/PrintMedicalAbstract";

function AddVitalSigns(data, setDatas) {
    const navigateto = useNavigate();

    const DiagnosisLabels = [
        {label:"Heart Break"},
        {label:""},
        {label:"Covid"},
    ]

    const TherapueticsLabels = [
        {label:"Paracetamols (Biogesic)"},
        {label:"Drug (Kremil S)"},
        {label:""},
    ]
    const [sample, setSample] = useState(data)
    const handleAddChange = (e) => {
        const { name, value } = e.target;
        setSample((prevState) => ({
          ...prevState,
          [name]: value,
        }));
    }

    const componentRef = useRef();
        const handlePrint = useReactToPrint({
            content: () => componentRef.current,
            // pageStyle: () => "@page { size: letter; margin: 5mm; }",
            // onAfterPrint: () => {
            // // navigate("/tables");
            // },
    });

    return (
        <div className="App">
            {/* <SidebarMenu /> */}
                <div className="col p-5 pt-4 manager-container overflow">
                    <div className="row pt-2 p-3">
                        <div className="col-1 text-center mt-2">
                            <img
                            src={backarrow}
                            alt="back"
                            className="backarrow"
                            width={25}
                            height={25}
                            onClick={() => navigateto(-1)}
                            ></img>
                        </div>
                        <div className="col font-big font-bold">MEDICAL ABSTRACT</div>
                    </div>
                    <div className="row pl-4">
                        <div className="row mt-2">
                            <div className="col-sm-12">
                            <CheckBtn
                                type={`inline`}
                                formLabel={`DIAGNOSES`}
                                labels={DiagnosisLabels}
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <CheckBtn
                                type={`inline`}
                                formLabel={`THERAPUETIC`}
                                labels={TherapueticsLabels}
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <TextArea
                                required
                                id="name"
                                type={`inline`}
                                formLabel={`PLAN`}
                                size={`sm`}
                                placeholder={``}
                                onChange={(e) => handleAddChange(e)}
                                name="plan"
                                // isError={}
                                errorMessage="This is an error"
                            />
                            </div>
                        </div>
                    </div>
                    <div className="row pl-4">
                        <div className="col-3">
                            <BtnSave label={"SAVE/PRINT"} onClick={handlePrint}></BtnSave>
                        </div>
                        <div style={{display: "none"}}>
                            <PrintMedicalAbstract ref={componentRef}></PrintMedicalAbstract>
                        </div>
                    </div>
                </div>
        </div>
    )
}
export default AddVitalSigns;